<!--
  Kommerzielle Landingpage & Cluster-HUB „Verkaufsautomat kaufen“.
  Kopf-Keyword + „Hersteller/Made in Germany“ (Zweit-KW). Zentraler Zweck:
  interne Verlinkung in alle Segment-Seiten. Modifier kaufen/mieten/outdoor
  als Anker. lp-* = gemeinsames Stylesheet.
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🛒</div>
      <span class="lp-eyebrow" i18n="@@va.hero.eyebrow">Hersteller aus Kiel · Made in Germany</span>
      <h1 class="title display" i18n="@@va.hero.h1">Verkaufsautomat kaufen</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@va.hero.lead">
        Verkaufe deine Produkte rund um die Uhr – bargeldlos, wetterfest und ohne Personal.
        Die <span class="tm">marktbox</span> ist dein Verkaufsautomat direkt vom Hersteller:
        entwickelt und produziert in Kiel.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@va.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#segmente" (click)="scrollTo($event, 'segmente')" i18n="@@va.hero.ctaAnchor">Für welche Produkte? ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Verkaufsautomat – Hersteller aus Kiel, made in Germany" i18n-alt="@@va.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@va.hero.badge">🇩🇪 made in Germany</span>
    </figure>
  </div>
</section>

<!-- ===== Vertrauens-/Firmenzahlen ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <div class="lp-stats reveal">
      <div class="lp-stat"><span class="lp-stat__n" i18n="@@va.stat1.n">seit 2019</span><span class="lp-stat__l" i18n="@@va.stat1.l">marktbox GmbH – Herstellung der marktbox seit 2021</span></div>
      <div class="lp-stat"><span class="lp-stat__n">42+</span><span class="lp-stat__l" i18n="@@va.stat2.l">Branchen im Einsatz</span></div>
      <div class="lp-stat"><span class="lp-stat__n" i18n="@@va.stat3.n">5 Länder</span><span class="lp-stat__l" i18n="@@va.stat3.l">Deutschland, Österreich, Schweiz, Dänemark &amp; Niederlande</span></div>
      <div class="lp-stat"><span class="lp-stat__n">Kiel</span><span class="lp-stat__l" i18n="@@va.stat4.l">Entwicklung &amp; Produktion – made in Germany</span></div>
    </div>
  </div>
</section>

<!-- ===== Segment-Hub (interne Verlinkung in den ganzen Cluster) ===== -->
<section id="segmente" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@va.seg.h2">Für welche Produkte eignet sich die marktbox?</h2>
    <p class="lp-intro reveal" i18n="@@va.seg.intro">
      Ein Automat, viele Anwendungen – für jedes Sortiment die passende Seite mit Details, Praxis und Preisen:
    </p>
    <div class="lp-grid">
      @for (s of segments; track s.slug) {
      <a class="lp-card reveal" [routerLink]="['/', s.slug]">
        <span class="lp-card__ico">{{ s.icon }}</span>
        <h3>{{ s.label }}</h3>
        <p>{{ s.label }} <span i18n="@@va.seg.view">ansehen →</span></p>
      </a>
      }
    </div>
  </div>
</section>

<!-- ===== Hersteller / Made in Germany + Produktionsvideo ===== -->
<section class="lp-section">
  <div class="content content--wide lp-media-grid">
    <div class="lp-video__text reveal">
      <span class="lp-eyebrow" i18n="@@va.mfr.eyebrow">Hersteller · Made in Germany</span>
      <h2 class="lp-h2" i18n="@@va.mfr.h2">Direkt vom Hersteller aus Kiel</h2>
      <p class="lp-lead" i18n="@@va.mfr.lead">
        Die marktbox wird nicht importiert, sondern in Kiel entwickelt und gebaut. Kurze Wege,
        deutscher Support und ein Automat, der laufend weiterentwickelt wird – kein Katalogprodukt von der Stange.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@va.mfr.li1">Entwicklung, Produktion &amp; Support aus einer Hand</li>
        <li i18n="@@va.mfr.li2">App-gesteuert, bargeldlos, wetterfest</li>
        <li i18n="@@va.mfr.li3">Abschließbare Klappen &amp; Diebstahlschutz</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@va.mfr.cta">Zum Shop</a>
      </div>
    </div>
    <div class="lp-video reveal">
      @if (!videoOpen) {
      <button type="button" class="lp-video__facade" [style.background-image]="'url(' + videoThumb + ')'"
        (click)="openVideo()" aria-label="Video abspielen: marktbox Produktion in Kiel" i18n-aria-label="@@va.mfr.videoAria">
        <span class="lp-video__play"></span>
      </button>
      } @else {
      <iframe [src]="videoUrl!" title="marktbox – Produktion in Kiel" i18n-title="@@va.mfr.videoTitle"
        allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>
      }
    </div>
  </div>
</section>

<!-- ===== Kaufen / Mieten / Outdoor (Modifier-Anker statt eigener Seiten) ===== -->
<section id="konditionen" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@va.kond.h2">Kaufen, mieten oder outdoor</h2>
    <div class="lp-price-grid">
      <div id="kaufen" class="lp-price reveal">
        <span class="lp-price__label" i18n="@@va.kond.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@va.kond.buyText">Einmalige Investition, dauerhaft dein Automat – ideal für den langfristigen Betrieb.</p>
      </div>
      <div id="mieten" class="lp-price reveal">
        <span class="lp-price__label" i18n="@@va.kond.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@va.kond.rentText">Planbare Kosten, niedrige Einstiegshürde – ideal zum Starten und Testen eines Standorts.</p>
      </div>
      <div id="outdoor" class="lp-price reveal">
        <span class="lp-price__label" i18n="@@va.kond.outLabel">Outdoor</span>
        <span class="lp-price__value" i18n="@@va.kond.outValue">wetterfest</span>
        <p i18n="@@va.kond.outText">Für draußen gebaut: am Feldrand, Hoftor oder auf dem Parkplatz – ganzjährig einsatzbereit.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@va.kond.cta">Verkaufsautomat konfigurieren</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@va.kond.fine">
      Rechnet sich das? <a [routerLink]="['/', links.blog, blogGeld]">Mit Automaten Geld verdienen</a> ·
      <a [routerLink]="['/', links.blog, blogKosten]">Laufende Kosten</a>
    </p>
  </div>
</section>

<!-- ===== Aufstellen & betreiben ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <span class="lp-eyebrow reveal" i18n="@@va.setup.eyebrow">Aufstellen &amp; betreiben</span>
    <h2 class="lp-h2 reveal" i18n="@@va.setup.h2">Verkaufsautomat aufstellen</h2>
    <p class="lp-intro reveal" i18n="@@va.setup.intro">
      Ein Verkaufsautomat steht dort, wo deine Kundschaft ist – am Hof, vor dem Laden, am Feldrand
      oder an gut sichtbaren Standorten mit Laufkundschaft. Er verkauft rund um die Uhr ohne Personal
      und wird so zu einem eigenständigen, unbemannten Verkaufspunkt: ob als zusätzlicher Absatzkanal
      neben dem Laden oder als Einstieg in die Direktvermarktung. Standort wählen, marktbox aufstellen,
      bestücken – der Verkauf läuft.
    </p>
    <div class="lp-cta reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@va.setup.cta">Modelle ansehen</a>
      <a class="lp-cta__ghost" [routerLink]="['/', 'automatenkiosk']" i18n="@@va.setup.kioskLink">Mehrere an einem Standort? → Automatenkiosk</a>
    </div>
  </div>
</section>

<!-- ===== Live-Link ===== -->
<section class="lp-section">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@va.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@va.live.h2">Jede Box zeigt live ihren Bestand</h2>
      <p class="lp-lead" i18n="@@va.live.lead">
        Jede marktbox hat ihren eigenen Live-Link: Kundschaft sieht in Echtzeit, was verfügbar ist –
        hier am Beispiel der Hofbäckerei Hömberg.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@va.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@va.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@va.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@va.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Hofbäckerei Hömberg: Echtzeit-Verfügbarkeit" i18n-title="@@va.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@va.live.cap">Live-Beispiel: Hofbäckerei Hömberg</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@va.mod.h2">Modelle</h2>
    <div class="lp-models">
      <a class="lp-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="lp-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Verkaufsautomat mit 39 Fächern" i18n-alt="@@va.mod39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lp-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@va.mod39.text">39 Fächer – für breites Sortiment und höhere Stückzahlen.</p>
          <span class="lp-model__more" i18n="@@va.mod39.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="lp-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="lp-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Verkaufsautomat mit 24 Fächern" i18n-alt="@@va.mod24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="lp-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@va.mod24.text">24 Fächer – kompakter Einstieg für den ersten Standort.</p>
          <span class="lp-model__more" i18n="@@va.mod24.more">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@va.faq.h2">Häufige Fragen zum Verkaufsautomat</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
    <p class="lp-fineprint reveal" i18n="@@va.faq.fine">
      Mehr Grundlagen im Ratgeber:
      <a [routerLink]="['/', links.blog, blogSmart]">Was smarte Verkaufsautomaten ausmacht</a>
    </p>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-section--muted lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@va.final.h2">Bereit für deinen Verkaufsautomaten?</h2>
    <p class="lp-lead" i18n="@@va.final.lead">Direkt vom Hersteller aus Kiel – kaufen oder mieten, in wenigen Schritten startklar.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@va.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
